import {useListView} from '../../core/ListViewProvider'
import {JudiListSearchComponent} from './JudiListSearchComponent'
import {JudiListToolbar} from './JudiListToolbar'

const JudiListHeader = () => {
  const {selected} = useListView()
  return (
    <>
      <div className='card-header border-0 pt-6 flex-column'>
        <div className="flex-xxl-grow-1 flex-grow-0">
          <JudiListSearchComponent />
        </div>
        <div className='card-toolbar flex-end'>
          <JudiListToolbar />
        </div>
      </div>
    </>
  )
}

export {JudiListHeader}
